import { ModalDialog } from './ModalFrame';
import { ModalCloseButton } from './ModalCloseButton';
import { useEffect, useId, useRef } from 'react';

/** Two monthly HT objectives, saved atomically. The advised break-even point
 * remains computed, not overwritten by the administrator's objective. */
export function RevenueGoalDialog({
  draft,
  onDraft,
  pointDraft,
  onPointDraft,
  onSave,
  onCancel,
  saving = false,
  error = null,
}: {
  readonly draft: string;
  readonly onDraft: (value: string) => void;
  readonly pointDraft: string;
  readonly onPointDraft: (value: string) => void;
  readonly onSave: () => void;
  readonly onCancel: () => void;
  readonly saving?: boolean;
  readonly error?: string | null;
}): React.JSX.Element {
  const ref = useRef<HTMLDialogElement>(null);
  const title = useId();
  useEffect(() => {
    ref.current?.showModal();
  }, []);
  return (
    <ModalDialog
      ref={ref}
      className="revenue-goal-overlay remuneration-goal-overlay"
      aria-labelledby={title}
      onCancel={onCancel}
      close={
        <ModalCloseButton
          className="remuneration-goal-overlay__close tosho-modal-close"
          aria-label="Fermer"
          onClick={onCancel}
        />
      }
    >
      <form
        className="remuneration-goal"
        onSubmit={(event) => {
          event.preventDefault();
          onSave();
        }}
      >
        <header className="tosho-modal-heading tosho-modal-header">
          <h2 id={title}>Objectifs de chiffre d’affaires</h2>
        </header>
        <label>
          Objectif de CA mensuel
          <span>
            <input
              type="number"
              min="1"
              max="10000000"
              step=".01"
              value={draft}
              onChange={(event) => onDraft(event.currentTarget.value)}
              autoFocus
            />
            €
          </span>
        </label>
        <label>
          Point zéro objectivé
          <span>
            <input
              type="number"
              min="1"
              max="10000000"
              step=".01"
              value={pointDraft}
              onChange={(event) => onPointDraft(event.currentTarget.value)}
            />
            €
          </span>
        </label>
        <p>
          Ces deux objectifs sont mensuels et exprimés en HT. Le point zéro conseillé reste calculé
          séparément d’après vos charges.
        </p>
        {error ? (
          <p className="tosho-feedback is-error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="remuneration-goal__actions">
          <button type="button" onClick={onCancel} disabled={saving}>
            Annuler
          </button>
          <button type="submit" disabled={saving}>
            {saving ? 'Enregistrement…' : 'Valider'}
          </button>
        </div>
      </form>
    </ModalDialog>
  );
}
